import React from 'react'
import { Bar, LinearComponentProps } from 'react-chartjs-2'
import * as chartjs from 'chart.js'
import { chartColors, rgbaColor } from 'components/charts/colors'

export type BarChartProps = LinearComponentProps

export const BarChart = (props: LinearComponentProps) => {
  const { data, options, ...rest } = props

  const withDefaultConfig: LinearComponentProps = {
    data(canvas: any) {
      let newData: chartjs.ChartData

      if (typeof data === 'function') {
        newData = data(canvas)
      } else {
        newData = data
      }

      return {
        ...newData,
        datasets: (newData.datasets || []).map((ds) => ({
          backgroundColor: chartColors.primary,
          barThickness: 10,
          ...ds,
        })),
      }
    },
    options: {
      ...options,
      legend: {
        display: false,
        ...options?.legend,
      },
      showLines: options?.showLines || false,
      tooltips: {
        mode: 'x-axis',
        xPadding: 20,
        yPadding: 10,
        displayColors: false,
        ...options?.tooltips,
      },
      hover: {
        mode: 'label',
        ...options?.hover,
      },
      scales: {
        ...options?.scales,
        gridLines: {
          drawBorder: false,
          ...options?.scales?.gridLines,
        },
        xAxes: (options?.scales?.xAxes || [{}]).map((xAxe) => ({
          ...xAxe,
          ticks: {
            fontColor: chartColors.grey,
            fontSize: 13,
            fontStyle: '500',
            fontFamily: 'Poppins',
            padding: 5,
            ...xAxe.ticks,
          },
          gridLines: {
            display: false,
            drawBorder: false,
            ...xAxe.gridLines,
          },
        })),
        yAxes: (options?.scales?.yAxes || [{}]).map((yAxe) => ({
          ...yAxe,
          ticks: {
            fontColor: chartColors.grey,
            fontSize: 14,
            fontStyle: '500',
            fontFamily: 'Poppins',
            maxTicksLimit: 5,
            padding: 15,
            min: 0,
            stepSize: 1,
            ...yAxe.ticks,
          },
          gridLines: {
            color: rgbaColor(chartColors.grey, 0.3),
            lineWidth: 2,
            zeroLineColor: rgbaColor(chartColors.grey, 0.3),
            zeroLineWidth: 2,
            drawBorder: false,
            ...yAxe.gridLines,
          },
        })),
      } as chartjs.LinearScale,
    },
  }

  return (
    <Bar {...withDefaultConfig} {...rest} />
  )
}
